<script lang="ts">
  import { AppState } from '../../etc/stores';
  import { Auth } from '../../services/auth';
  import { Container } from '../../services/container';

  const auth = Container.get(Auth);

  const { position } = $AppState.settings;
</script>

<div class="twism-popup--container -{position} {auth.provider}">
  <slot />
</div>

<style lang="scss">
  .twism-popup {
    &--container {
      background-color: #ffffff;
      box-shadow: 0px 14px 48px -13px rgba(4, 33, 67, 0.26);
      border-radius: 16px;
      width: 360px;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      box-sizing: border-box;
      padding-bottom: 16px;
      transform-origin: inherit;
      max-height: 77vh;
      position: relative;
      overflow-y: auto;
      overflow-x: hidden;
      overscroll-behavior: contain;

      &::-webkit-scrollbar {
        display: none;
      }
      @media screen and (max-width: 468px) {
        max-height: calc(100vh - 36px);
        width: 100%;
      }
    }
  }
</style>
